import { GET_ERRORS, CLEAR_ERRORS } from "../actions/types";

import isEmpty from "../validation/is-empty";

const initialState = {};

function errorReducer(state, action) {
  if (isEmpty(state)) {
    state = initialState;
  }

  switch (action.type) {
    case GET_ERRORS:
      return action.payload;
    case CLEAR_ERRORS:
      return {};
    default:
      return state;
  }
}

export default errorReducer;
